module.exports = __webpack_public_path__ + "static/media/error_icon.e3362d87.svg";